export const REFRESH_TOKEN_HEADER = "x-refresh-token";
export const ACCESS_TOKEN_HEADER = "x-access-token";
